export default "__VITE_ASSET__DnvvPgGw__"